module.exports = __webpack_public_path__ + "static/media/pilar_lingkungan.b2a5cab9.jpg";